import React, { Component } from "react";
import { Container, Row, Col, Table, Form, Badge, Card } from "react-bootstrap";
import CommonRowId from "../components/CommonRowId";
class DataTableDashboardTypeA extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    render = () => {

        let props = this.props;

        let { data, title, icon, bg = 'primary', column } = props;
        let { loading } = this.state;

        return (
            <Card className="card-border mb-5">
                <Card.Header className={`card-header-action bg-${bg}`}>
                    <h6 className="text-white">{icon && <i className={`${icon} me-2`}></i>}{title}</h6>
                </Card.Header>
                <Card.Body style={{ maxHeight: '350px', position: 'relative', overflowY: 'auto' }}>
                    <Row>
                        <Col md={12}>
                            <Table
                                responsive
                                // borderless
                                className={`table-advance table-visible`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p"></th>
                                        <th className="th-width-100p">ประเภทนักศึกษา</th>
                                        <th className="th-width-100p">ระดับการศึกษา</th>
                                        <th className="th-width-150p">คณะ/สาขา</th>
                                        <th className="th-width-50p text-center">
                                            <span>จำนวนผู้ประกอบการที่สนับสนุน</span>
                                            {/* <span style={{ display: 'block' }}>Type A 100%</span> */}
                                        </th>
                                        <th className="th-width-50p text-center">จำนวน (คน)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.rows.map((row, index) => (
                                        <React.Fragment key={index}>
                                            <tr className={((index % 2) === 1) ? 'striped-row' : ''}>
                                                <td className="th-td-align-center">
                                                    <CommonRowId rowId={index + 1} />
                                                </td>                                                

                                                <td className="text-truncate" title={row.type}>
                                                    {row.type}
                                                </td>

                                                <td className="text-truncate text-left" title={row.educationLevel}>
                                                    {/* <Badge className="badge-md me-1 mt-2" bg= {row.educationLevel === 1 ? "info" : "success"} pill>{row.educationLevel === 1 ? "ปวช." : "ปวส."}</Badge> */}
                                                    <Badge className="badge-md me-1 mt-2" bg="success" pill>
                                                        {row.educationLevel || '-'}
                                                    </Badge>
                                                </td>

                                                <td className="text-truncate" title={row.faculty || '-'}>
                                                    {row.faculty || '-'}
                                                </td>

                                                <td className="text-end text-center" title={row.industry}>
                                                    {row.recruit}
                                                </td>

                                                <td className="text-end fw-bold text-center">
                                                    {row.count.toLocaleString()}
                                                </td>
                                            </tr>

                                            <tr className="table-row-gap">
                                                <td colSpan={6} />
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>

                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export default DataTableDashboardTypeA;